/**
 * Clean bilaga — the frame-less attachment (ADR-0061) as blocks.
 *
 * Two blocks, both reusable by any frame-less or framed document:
 *
 *  - `clean_bilaga.letterhead` — logos always, a configurable title row
 *    toggled by "Lägg till sidhuvud", never a form number.
 *  - `clean_bilaga.custom-sections` — the per-contract "Egna sektioner"
 *    (ADR-0060), the shared `common/custom-sections` block under this
 *    family's key. Frame-less documents place one instance with no anchor
 *    (the whole body); framed documents place one instance after every
 *    declared section, each rendering only the customs anchored there.
 */
import { customSectionsBlockDefinition } from '../common/custom-sections.js';
import { letterhead } from '../common/shared.js';
import { str } from '../lib.js';
export { CUSTOM_SECTIONS_KEY, customSectionRef, normalizeCustomSections, readCustomSections, resolveCustomAfterRef, } from '../common/custom-sections.js';
export const customSections = customSectionsBlockDefinition('clean_bilaga.custom-sections');
/**
 * The clean frame's letterhead. Delegates to `common.letterhead` for the
 * brand marks so a clean document and a framed one brand identically; only
 * the title rule differs (configurable, toggleable, no form number).
 */
export const cleanLetterhead = {
    blockKey: 'clean_bilaga.letterhead',
    version: 'v1',
    plane: 'shared',
    status: 'published',
    language: 'sv-SE',
    title: 'Sidhuvud (rent dokument)',
    summary: 'Owner + customer brand marks with an optional, user-titled heading row; no form number.',
    slots: [
        {
            key: 'document_title',
            label: 'Dokumenttitel',
            type: 'text',
            required: true,
            help: 'Visas överst i dokumentet (om sidhuvud är på) och blir bilagans namn.',
        },
        {
            key: 'show_header',
            label: 'Lägg till sidhuvud',
            type: 'boolean',
            default: true,
            help: 'Visar dokumenttiteln under logotyperna. Logotyperna visas alltid.',
        },
    ],
    compile: (input, ctx) => {
        const title = str(input.document_title) ?? str(input.default_title) ?? 'Bilaga';
        const showHeader = input.show_header !== false;
        return letterhead.compile({ title: showHeader ? title : null, form_number: null }, ctx);
    },
};
export const CLEAN_BILAGA_BLOCKS = [cleanLetterhead, customSections];
//# sourceMappingURL=blocks.js.map